<template>
    <div class="progress progress-striped active">
        <div class="progress-bar"
             :class="'progress-bar-' + (color || 'primary')"
             role="progressbar"
             aria-valuemin="0" aria-valuemax="100"
             :aria-valuenow="percentage"
             :style="{width: percentage + '%' }">
            <span class="sr-only"> {{  }}%</span>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['percentage', 'color']
    };
</script>